<template>
    <div class="d-flex flex-column page-wrapper">
        <page-header>
            <span v-if="jointBorrower == false"><span v-if="editMode">{{ $t("message.edit" )}}</span> {{ $t("message.personalReference" )}}</span>
            <span v-if="jointBorrower == true"><span v-if="editMode">{{ $t("message.edit" )}}</span> {{ $t("message.primaryApplicantPersonalReference" )}}</span>
        </page-header>
        <div class="container d-flex flex-column align-items-center page-container">
            <div class="d-flex flex-row justify-content-around steps-container">
                <div class="dot previous-dot"></div><!-- Identification -->
                <div class="dot previous-dot"></div><!-- Contact Info -->
                <div class="dot previous-dot"></div><!-- Other Info -->
                <div class="dot current-dot" v-if="primaryReferenceRequired == true"/><!-- References -->
                <div class="dot next-dot" v-if="jointBorrower == true"/><!-- Joint Identification -->
                <div class="dot next-dot" v-if="jointBorrower == true"/><!-- Joint Contact Info -->
                <div class="dot next-dot" v-if="jointBorrower == true"/><!-- Joint Other Info -->
                <div class="dot next-dot" v-if="jointBorrower == true && jointReferenceRequired == true"/><!-- Joint References -->
                <div class="dot next-dot"></div><!-- Review -->
            </div>
            <p class="explanation-text">Please add contact information for your personal reference.</p>
            <div class="d-flex flex-column align-items-center align-content-center justify-content-center form-container">
                <b-form @submit.prevent="submit" novalidate>
                    <b-form-group :id="$id('reference-'+index)" v-for="(item, index) in $v.references.$each.$iter" :key="index" class="margin-bottom-10">
                        <label class="form-label more-info-section-header">Reference ({{Number(index) + 1}})</label>
                        <div class="more-info-section reference">
                            <b-form-group class="form-label" label="First Name">
                                <b-form-input :id="$id('firstName-'+index)" v-model="item.$model.firstName"></b-form-input>
                                <div class="field-error-message" v-if="!item.firstName.required && item.firstName.$dirty">Please enter your reference First Name</div>
                            </b-form-group>
                            <b-form-group class="form-label" label="Last Name">
                                <b-form-input :id="$id('lastName-'+index)" v-model="item.$model.lastName"></b-form-input>
                                <div class="field-error-message" v-if="!item.lastName.required && item.lastName.$dirty">Please enter your reference Last Name</div>
                            </b-form-group>
                            <b-form-group class="form-label" label="Street Address">
                                <b-form-input :id="$id('address1-'+index)" type="text" v-model="item.$model.address1"/>        
                                <div class="field-error-message" v-if="!item.address1.required && item.address1.$dirty">An address for each reference is required</div>        
                            </b-form-group>
                            <b-form-group class="form-label" label="Address Line 2">
                                <b-form-input type="text" :id="$id('address2-'+index)" v-model="item.$model.address2"/>        
                            </b-form-group>
                            <b-form-group class="form-label" label="City">
                                <b-form-input type="text" :id="$id('city-'+index)" v-model="item.$model.city"/>        
                                <div class="field-error-message" v-if="!item.city.required && item.city.$dirty">A city for each reference is required</div>        
                            </b-form-group>
                            <b-form-group class="form-label" label="State">
                                <b-form-select class="form-control" :id="$id('state-'+index)" v-model="item.$model.state" :options="stateOptions"></b-form-select>
                                <div class="field-error-message" v-if="!item.state.required && item.state.$dirty">A state for each reference is required</div>        
                            </b-form-group>
                            <b-form-group class="form-label" label="Zip Code">
                                <b-form-input type="tel" :id="$id('zipCode-'+index)" v-model="item.$model.zipCode" v-mask="'#####', '#####-####'"/>        
                                <div class="field-error-message" v-if="!item.zipCode.required && item.zipCode.$dirty">A Zip Code for each reference is required</div>        
                                <div class="field-error-message" v-if="!item.zipCode.zipCodeValidation && item.zipCode.minLength && item.zipCode.$dirty && item.state.required">This Zip Code is not valid for the selected state</div>        
                                <div class="field-error-message" v-if="!item.zipCode.minLength && item.zipCode.$dirty">Please enter a valid Zip Code</div>        
                            </b-form-group>                        
                            <b-form-group class="form-label" label="Phone Number">
                                <b-input-group>
                                <b-form-input type="tel" :id="$id('phoneNumber-'+index)" v-model="item.$model.phoneNumber" v-mask="'(###)###-####'"/>
                                <b-input-group-append>
                                    <b-dropdown variant="highlight" :id="$id('phoneTypes-'+index)" :no-caret="true">
                                        <template #button-content>
                                        <div class="min-width-70">
                                            {{ item.$model.phoneTypeText }}
                                        </div>
                                        </template>
                                        <b-dropdown-item-button :pressed="option.value === item.$model.phoneType" @click="updatePhoneType(item.$model, option)" v-for="option in phoneTypes" :key="option.value">{{ option.name }}</b-dropdown-item-button>
                                    </b-dropdown>
                                </b-input-group-append>
                                </b-input-group>     
                                <div class="field-error-message" v-if="!item.phoneNumber.required && item.phoneNumber.$dirty">A phone number for each reference is required</div>
                                <div class="field-error-message" v-if="!item.phoneNumber.minLength && item.phoneNumber.$dirty">Please enter a valid Phone Number</div>   
                                <div class="field-error-message" v-if="!item.phoneType.required && item.phoneType.$dirty">Please select the Phone Type</div>
                            </b-form-group>
                            <b-form-group class="form-label" label="How do you know this person?">
                                <b-form-input :id="$id('relationship-'+index)" v-model="item.$model.relationship"></b-form-input>
                                <div class="field-error-message" v-if="!item.relationship.required && item.relationship.$dirty">A relationship for each reference is required</div>                        
                            </b-form-group>
                            <b-form-group class="form-label" label="How long have you known this person?">
                                <b-input-group append="Years">
                                    <b-form-input type="number" :id="$id('relationshipDuration-'+index)" v-model="item.$model.relationshipDuration" min="0" class="width-30" />
                                </b-input-group>
                                <div class="field-error-message" v-if="!item.relationshipDuration.required && item.relationshipDuration.$dirty">An amount of time for each reference is required</div>                        
                            </b-form-group>
                        </div>
                    </b-form-group>
                    <div class="d-flex flex-column justify-content-between align-items-center final-action-div">
                        <b-button variant="secondary" type="submit" :id="$id('next')" class="btn btn-width">
                            <span v-if="!editMode">{{ $t("message.next" )}}</span>
                            <span v-if="editMode">{{ $t("message.saveEdit" )}}</span>
                        </b-button>
                        <b-button variant="light" @click="back()" :id="$id('back')" class="btn btn-width">
                            <span v-if="!editMode">{{ $t("message.back" )}}</span>
                            <span v-if="editMode">{{ $t("message.cancel" )}}</span>
                        </b-button>
                    </div>
                </b-form>                              
            </div> 
        </div>
        <page-footer />
        <b-modal ref="errorModalRef" body-text-variant="dark" header-text-variant="dark" centered ok-only ok-variant="secondary" title="Missing Information">{{ $t('message.missingRequiredFieldsMsg') }}</b-modal>
    </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import { required, minLength, minValue, helpers } from "vuelidate/lib/validators";
import { mask } from 'vue-the-mask';
import { zipCodeValidation } from "@/validators/validators.js";
import { mapState, mapGetters } from "vuex";
const alphaNum = helpers.regex('alphaNum', /^[a-zA-Z0-9 ' . -]*$/);
const alphaDash = helpers.regex('alphaDash', /^[a-zA-Z ' . -]*$/);

export default {
    name: 'References',
    components: {
        Datepicker
    },
    directives: {
        mask
    },
    mounted() {
        this.references = this.primaryReferences;
        if(this.references == null || this.references.length == 0) {
            this.initializeReferences();
        }
    },
    data() {
        return {
            phoneTypes: [
                { name: 'Home', value: 'Home Phone'  },
                { name: 'Cell', value: 'Personal Cell' },
                { name: 'Business', value: 'Business Phone' },
            ],
            references: [],
        }
    },
    computed: {
        ...mapState([
            "editMode",
            "currentState",
            "isJointApplication",
            "primaryApplicant",
            "primaryReferences",
            "primaryReferenceCount",
            "stateOptions",
        ]),
        ...mapGetters([
            "primaryReferenceRequired",
            "jointReferenceRequired",
        ]),
        jointBorrower: {
            get() {
                return this.isJointApplication;
            }
        },
    },
    methods: {
        submit: function() {
            this.$v.$touch();
            console.info('$v', this.$v);
            if(this.$v.$invalid) {
                this.$refs.errorModalRef.show();
            } else if(this.editMode) {
                this.$router.push("review");
            } else if (this.jointBorrower) {
                this.$router.push("jointidentification");
            } else {
                this.$router.push('review');
            }
        },
        back() {
            if(this.editMode) {
                this.$store.replaceState(this.currentState);
                this.$router.push("review");
            } else {
                this.$router.push('otherinformation');
            }
        },
        updatePhoneType(vm, opt) {
            vm.phoneTypeText = opt.name;
            vm.phoneType = opt.value;
        },
        initializeReferences() {
            for (let i = 0; i < this.primaryReferenceCount; i++) {
                let reference = {};
                reference.firstName = '';
                reference.lastName = '';
                reference.address = {
                    address1: '',
                    city: '',
                    state: '',
                    zipCode: ''
                };
                reference.phoneNumber = '';
                reference.phoneType = 'Personal Cell';
                reference.phoneTypeText = 'Cell';
                reference.relationship = '';
                reference.relationshipDuration = null;
                this.references.push(reference);
            }
        }
    },
    validations: {
        references: {
            $each: {
                firstName: {
                    required        
                },
                lastName: {
                    required
                },
                address1: {
                    required,
                    alphaNum
                },
                city: {
                    required,
                    alphaDash
                },
                state: {
                    required,
                },
                zipCode: {
                    required,
                    zipCodeValidation (value, currItem) {
                        return zipCodeValidation(currItem.state)(value);
                    },
                    minLength: minLength(5)
                },
                phoneNumber: {
                    required,
                    minLength: minLength(13)
                },
                phoneType: {
                    required,
                },
                relationship: {
                    required
                },
                relationshipDuration: {
                    required,
                    minValue: minValue(1)
                },
            }
        },
    }
}
</script>